<template>
    <div class="d-flex flex-wrap justify-content-between">
        <!-- TODO - Adicionar traduções -->
        <SummaryBox
            :title="$t('targets.progress')"
            :subtitle="$t('objectives.objectives')"
            :alert="objectivesAvarage < 0.3"
            :success="objectivesAvarage >= 0.7"
            :info="formatPercentage(objectivesAvarage * 100) + '%'"
        />
        <SummaryBox
            :title="$t('targets.progress')"
            :subtitle="$t('insights.keyResults')"
            :alert="keyResultsAvarage < 0.3"
            :success="keyResultsAvarage >= 0.7"
            :info="formatPercentage(keyResultsAvarage * 100) + '%'"
        />
        <SummaryBox
            :info="checkinsCount"
            :title="$t('people.amount')"
            :subtitle="$t('calculation.checkIns')"
        />
        <SummaryBox
            :info="lateCheckins"
            :subtitle="$t('okr.late')"
            :title="$t('calculation.checkIns')"
        />
    </div>
</template>

<script>
import SummaryBox from '../summary-box'
import { getOkrSummary } from './api'
import { getParam } from '@/lib/url'
import { formatPercentage, decimalFormat } from '@/lib/utils'

export default {
    name: 'ObjectivesSummary',
    components: { SummaryBox },
    data() {
        return {
            periods: [],
            userID: getParam('id', this),
            checkinsCount: 0,
            keyResultsAvarage: 0,
            lateCheckins: 0,
            objectivesAvarage: 0,
        }
    },
    mounted() {
        this.periods = this.$store.state.filters.periods
        this.$store.watch(
            state => state.filters.periods,
            periods => {
                this.periods = periods
            }
        )
    },
    methods: {
        getSummaryFromApi() {
            getOkrSummary(this.userID, this.periods).then(summaries => {
                this.keyResultsAvarage = summaries.key_results_avarage
                this.checkinsCount = summaries.checkins_count
                this.lateCheckins = summaries.late_checkins
                this.objectivesAvarage = summaries.objectives_avarage
            })
        },
        formatPercentage(number) {
            if (number) {
                return formatPercentage(decimalFormat(number))
            }
            return 0
        },
    },
    watch: {
        periods: function() {
            this.getSummaryFromApi()
        },
    },
}
</script>

<style>
</style>
